import Vue from 'vue'
import VeeValidate from 'vee-validate'
import dictionary from './dictionary'

Vue.use(VeeValidate, {
  locale: 'it',
  dictionary
})
